import React, { useContext, useEffect, useState } from "react";

import { PopUpContext } from "../../contexts/popUpContext";

import lbl from "../../data/Labels.json";
import db from "../../services/query";

import PopUpParagraph from "../common/PopUpParagraph";
import PopUpList from "../common/PopUpList";
import PenIcon from "../../icons/pen-icon";
import DownloadIcon from "../../icons/download-icon";
import DeleteIcon from "../../icons/delete-icon";

const PastBalancePopUp = () => {
  const {
    togglePopUp,
    popUp: { cache },
  } = useContext(PopUpContext);

  const [data, getData] = useState([]);

  useEffect(async () => {
    const ac = new AbortController();

    await db.getAll(`students/${cache}/balance`).then(({ data: { data } }) => {
      getData({
        data: data[0],
        listItems: [
          {
            title: "ثبت کننده",
            value: data[0]["modified_by"],
          },
          {
            title: "تایید کننده",
            value: data[0]["verified_by"],
          },
          {
            title: "تاریخ ارزیابی",
            value: data[0]["verification_date"],
          },
        ],
      });
    });

    return () => ac.abort();
  }, []);

  return (
    <div className="pop-up-container">
      <div className="pop-up-wrapper">
        <div className="pop-up-head">
          <p>{lbl.OpeningBalance}</p>
        </div>
        <div className="pop-up-body">
          <div className="pop-up-item-with-control">
            <div className="data">
              <p className="title">{lbl.Amount}</p>
              <b>{data?.data?.amount}</b>
            </div>
            <div className="controls">
              <a href={data?.data?.attachment} download target="_blank">
                <button className="fill">
                  <span>
                    {lbl.Document}
                    <DownloadIcon />
                  </span>
                </button>
              </a>
              <button
                onClick={() =>
                  togglePopUp({ form: "student-balance-form", edit: data })
                }
              >
                <PenIcon />
              </button>
              <button className="delete-btn"
                onClick={() =>
                  togglePopUp({ form: "delete", route: 'students/balance', id: data?.data?.id })
                }
              >
                <DeleteIcon />
              </button>
            </div>
          </div>
          <PopUpParagraph title={lbl.Remark} paragraph={data?.data?.remark} />
          <PopUpList items={data.listItems} />
        </div>
        <div className="pop-up-buttons">
          <button onClick={() => togglePopUp()}>{lbl.Cancel}</button>
        </div>
      </div>
    </div>
  );
};

export default PastBalancePopUp;
